import React, { useState } from "react";
import { TextField, FormControlLabel, Checkbox, Rating } from "@mui/material";
import cogoToast from "cogo-toast";
import { useParams } from "react-router-dom";
import { postWebinarFeedbackForm } from "../api/utils";

export default function WebinarFeedback() {
    const { id: responseId } = useParams();

    const [rating, setRating] = useState(0);
    const [comments, setComments] = useState("");
    const [recommendFlag, setRecommendFlag] = useState(false);
    const [showError, setShowError] = useState(false);

    const submitFeedback = async () => {
        if (!rating) {
            setShowError(true);
            cogoToast.info("Please provide a rating");
            return;
        }

        try {
            const res = await postWebinarFeedbackForm(
                {
                    rating: rating.toString(),
                    comments,
                    recommend_flag: recommendFlag,
                },
                responseId
            );

            if (res.status === "ok") {
                cogoToast.success("Thank you for your feedback!");
                setRating(0);
                setComments("");
                setRecommendFlag(false);
                setShowError(false);
            } else {
                cogoToast.error(res.errors?.[0] || "Submission failed");
            }
        } catch (error) {
            cogoToast.error("Something went wrong while submitting feedback.");
        }
    };

    return (
        <main className="wrapper">
            <section className="page-hero-sec py-5">
                <div className="container">
                    <div className="row justify-content-center text-center mb-4">
                        <div className="col-lg-8">
                            <h1 className="tc-primary head-font pb-3">Workshop Feedback</h1>
                            <p className="fs-5">
                                We value your opinion. Please take a moment to share your feedback.
                            </p>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6">
                            {/* Rating */}
                            <div className="mb-4">
                                <label className="form-label mb-2 d-block" style={{ fontWeight: 600, fontSize: 19 }}>
                                    Your Rating
                                </label>
                                
                                <Rating
                                    name="rating"
                                    value={rating}
                                    size="large"
                                    onChange={(event, newValue) => setRating(newValue)}
                                />
                                {showError && !rating && (
                                    <span className="text-danger" style={{ fontSize: 14 }}>
                                        Required
                                    </span>
                                )}
                             
                            </div>

                            {/* Comments */}
                            <div className="mb-4">
                                <TextField
                                    fullWidth
                                    label="Comments"
                                    value={comments}
                                    required
                                    multiline
                                    rows={6}
                                    style={{ marginTop: 25, background: "#e0e5ef" }}
                                    onChange={(e) => {
                                        setComments(e.target.value);
                                    }}
                                    margin="dense"
                                    error={showError ? comments.length === 0 : null}
                                    id="standard-error-helper-text"
                                    InputProps={{
                                        "&.MuiFormHelperText-root.Mui-error": {
                                            background: "orange",
                                        },
                                    }}
                                    sx={{
                                        "& input": {
                                            background: "#e0e5ef",
                                        },
                                    }}
                                    inputProps={{ maxLength: 500 }}
                                />
                            </div>

                            {/* Recommendation Checkbox */}
                            <div className="mb-4">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={recommendFlag}
                                            onChange={(e) => setRecommendFlag(e.target.checked)}
                                        />
                                    }
                                    label="Would you recommend this webinar to others?"
                                />
                            </div>

                            {/* Submit Button */}
                            <div className="col-lg-12 mt-4">
                                <button
                                    onClick={submitFeedback}
                                    type="submit"
                                    className="link_btn mt-4 mx-auto"
                                    style={{ marginBottom: 50 }}
                                >
                                    Submit Feedback
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
